// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDkGPHyn9IZxH9qYidvPCicByzPLJxgE2U",
  authDomain: "slickapi-b8989.firebaseapp.com",
  projectId: "slickapi-b8989",
  storageBucket: "slickapi-b8989.firebasestorage.app",
  messagingSenderId: "180224212968",
  appId: "1:180224212968:web:2032abf989cf39dd1b6e5d",
  measurementId: "G-5KZJTJMDG2"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);

const auth = getAuth(app);

export { auth };